import { render, staticRenderFns } from "./UpdateTitle.vue?vue&type=template&id=3332eba0&scoped=true"
import script from "./UpdateTitle.vue?vue&type=script&lang=js"
export * from "./UpdateTitle.vue?vue&type=script&lang=js"
import style0 from "./UpdateTitle.vue?vue&type=style&index=0&id=3332eba0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3332eba0",
  null
  
)

export default component.exports